import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyA-UfAvjq_mE25NKECUXyYQDaCe8uEVoCw",
    authDomain: "p-a-plans.firebaseapp.com",
    projectId: "p-a-plans",
    storageBucket: "p-a-plans.appspot.com",
    messagingSenderId: "648417455803",
    appId: "1:648417455803:web:f619b3b4904132c283439e",
    measurementId: "G-ZW5ZMV8RQ1"
};
const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);
export const auth = getAuth(app);
export const storage = getStorage(app);